/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLogout = createReactComponent("logout", "IconLogout", [
  [
    "path",
    {
      d: "M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2",
      key: "svg-0"
    }
  ],
  ["path", { d: "M9 12h12l-3 -3", key: "svg-1" }],
  ["path", { d: "M18 15l3 -3", key: "svg-2" }]
]);

export { IconLogout as default };
//# sourceMappingURL=IconLogout.js.map
